<template>
  <svg viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.4818 1C24.1781 1 27.3337 5.47 27.3337 9.64C27.3337 18.085 14.2374 25 14.0003 25C13.7633 25 0.666992 18.085 0.666992 9.64C0.666992 5.47 3.82255 1 8.51884 1C11.2151 1 12.9781 2.365 14.0003 3.565C15.0225 2.365 16.7855 1 19.4818 1Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
